import React from "react";
import { X, Calendar } from "lucide-react";

export default function UserFormModal({ mode, form, setForm, err, busy, onClose, onSubmit }) {
  const isEdit = mode === "edit";
  return (
    <div className="fixed inset-0 bg-black/70 z-50 flex items-center justify-center p-4">
      <div className="glass rounded-2xl border border-slate-700 w-full max-w-md p-6">
        <div className="flex items-center justify-between mb-4">
          <h2 className="font-heading text-2xl font-extrabold uppercase">
            {isEdit ? "Manage User" : "Create User"}
          </h2>
          <button onClick={onClose} className="p-1 hover:bg-slate-800 rounded"><X size={18} /></button>
        </div>
        <form onSubmit={onSubmit} className="space-y-3">
          <Field label="Email">
            <input required disabled={isEdit} type="email" value={form.email}
              onChange={e => setForm({ ...form, email: e.target.value })}
              data-testid="user-form-email"
              className="w-full px-3 py-2 rounded bg-slate-800 border border-slate-700 disabled:opacity-60" />
          </Field>
          <Field label="Name">
            <input type="text" value={form.name} onChange={e => setForm({ ...form, name: e.target.value })}
              data-testid="user-form-name"
              className="w-full px-3 py-2 rounded bg-slate-800 border border-slate-700" />
          </Field>
          <Field label={isEdit ? "New Password (leave blank to keep)" : "Password"}>
            <input required={!isEdit} type="text" value={form.password}
              onChange={e => setForm({ ...form, password: e.target.value })}
              data-testid="user-form-password"
              className="w-full px-3 py-2 rounded bg-slate-800 border border-slate-700" />
          </Field>
          <div>
            <label className="text-xs font-semibold uppercase text-slate-400 mb-1 flex items-center gap-2">
              <Calendar size={12} /> Expiry Date
            </label>
            <input type="date" value={form.expiry_date}
              onChange={e => setForm({ ...form, expiry_date: e.target.value })}
              data-testid="user-form-expiry"
              className="w-full px-3 py-2 rounded bg-slate-800 border border-slate-700" />
            <p className="text-xs text-slate-500 mt-1">Leave blank for no expiry</p>
          </div>
          <label className="flex items-center gap-2 text-sm cursor-pointer">
            <input type="checkbox" checked={form.is_active}
              onChange={e => setForm({ ...form, is_active: e.target.checked })}
              data-testid="user-form-active" />
            <span>Active</span>
          </label>
          {err && <div className="text-sm p-2 rounded bg-red-500/10 border border-red-900 text-red-300">{err}</div>}
          <button type="submit" disabled={busy} data-testid="user-form-submit"
            className="w-full px-4 py-2.5 rounded-lg bg-blue-600 hover:bg-blue-700 disabled:opacity-60 font-semibold">
            {busy ? "Saving..." : isEdit ? "Save Changes" : "Create User"}
          </button>
        </form>
      </div>
    </div>
  );
}

function Field({ label, children }) {
  return (
    <div>
      <label className="block text-xs font-semibold uppercase text-slate-400 mb-1">{label}</label>
      {children}
    </div>
  );
}
